<template>
  <div class="flex flex-col h-screen">
    <PortalAppBanner
      v-if="props.show_portal_app_banner"
      :portalAppBanner="props.portal_app_banner"
    />
    <Header />
    <div class="z-10 flex flex-1 overflow-hidden">
      <Sidebar v-if="renderDesktopSidebar" />
      <main scroll-region class="flex-1 w-full overflow-y-scroll">
        <DefaultPageWrapper v-if="renderDefaultPageWrapper">
          <slot />
        </DefaultPageWrapper>
        <slot v-else />
      </main>
    </div>

    <FlashMessage class="mt-20" />

    <GoogleTagManagerScripts
      v-if="props.tenant.company.google_tag_manager_id"
      :googleTagManagerId="props.tenant.company.google_tag_manager_id"
    />
  </div>
</template>

<script setup>
import { ref, provide, computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

import DefaultPageWrapper from '@/Components/Company/PageWrapper/DefaultPageWrapper'
import FlashMessage from '@/Components/Shared/FlashMessage'
import Header from '@/Components/Customer/Header/Header'
import PortalAppBanner from '@/Components/Shared/PortalAppBanner.vue'
import Sidebar from '@/Components/Customer/Sidebar/Sidebar'

import GoogleTagManagerScripts from '@/Components/Customer/OrderForms/LayoutParts/GoogleTagManagerScripts'

const { props } = usePage()

const renderDesktopSidebar = computed(() => props.value.meta?.renderDesktopSidebar ?? true)

const renderDefaultPageWrapper = computed(() => props.value.meta?.renderDefaultPageWrapper ?? true)

const sidebarOpen = ref(false)
provide('sidebarOpen', sidebarOpen)

const toggleSidebarOpen = () => (sidebarOpen.value ^= true)
provide('toggleSidebarOpen', toggleSidebarOpen)
</script>
